import React, { useEffect, useMemo } from 'react';
import cx from 'classnames';

import { constants, useBetslipState } from '@atlas/core';
import { BetOdds, Button, Label } from '@atlas/ui';

import { emptySelectedBet } from 'common/Betslip/BetslipClassic';
import { useLocalBetslip } from 'common/Betslip/LocalBetslipContext';
import { useNotificationsUIContext } from 'common/Popup/NotificationsUIContext';

const IFrameFlyingBetslip = ({ showBottomNavigation }) => {
  const { selectedBetTypeIndex, togglePopup } = useLocalBetslip();
  const { betItems, betTypes, settings } = useBetslipState();
  const { setIsFlyingBetslip } = useNotificationsUIContext();
  const selectedBet = betTypes[selectedBetTypeIndex] || betItems[0] || emptySelectedBet;
  const isFlyingBetslip = betItems.length > 0;

  const selectedBetTypeComponent = useMemo(() => {
    if (selectedBet.betType === constants.BET_TYPE.SYSTEM) {
      return (
        <>
          <Label
            message="betslip_button_system"
            params={{
              outcomeAmount: selectedBet.outcomeAmount,
              winCombinationSize: selectedBet.winCombinationSize,
            }}
          />
          <span className="bet-type-count">
            ({`${selectedBet.winCombinationSize}/${selectedBet.outcomeAmount}`})
          </span>
        </>
      );
    }

    return (
      <span>
        <Label message={`betslip_button_${selectedBet.betType || 'single'}`} />
        {selectedBet.betType === constants.BET_TYPE.MULTIPLE && (
          <span className="bet-type-count">({betItems.length})</span>
        )}
        :
      </span>
    );
  }, [selectedBet]);

  const betslipMobileType = useMemo(() => {
    if (settings.mobileType === 'european') {
      return <Label message="betslip" />;
    }
    return (
      <>
        {selectedBetTypeComponent}
        {selectedBet.betType !== constants.BET_TYPE.SYSTEM && (
          <BetOdds className="odd-amount" odds={selectedBet.odds} />
        )}
      </>
    );
  }, [settings.mobileType, selectedBet]);

  useEffect(() => {
    setIsFlyingBetslip(isFlyingBetslip);
  }, [isFlyingBetslip]);

  if (!isFlyingBetslip) return null;

  return (
    <Button
      className={cx('flying-betslip-button', !showBottomNavigation && 'without-navigation')}
      onClick={togglePopup}
    >
      {betslipMobileType}
    </Button>
  );
};

export default IFrameFlyingBetslip;
